import React from "react";
import AjudaModal from "./AjudaModal";

function AjudaAgenda({ onTancar }) {
  return (
    <AjudaModal
      id="agenda-ajuda-title"
      titol="Com funciona l'Agenda"
      lead="L'Agenda és la safata del dia a dia: recull recados i programa feina. No és el calendari laboral ni les tasques d'un Treball."
      onTancar={onTancar}
    >
      <section className="dv2-help-section">
        <h4>Per a què serveix</h4>
        <p>
          Apuntar el que arriba de fora (una trucada, un correu, un recado) i el que tu o un company heu de fer
          (presentar un pressupost, una reunió, un recordatori). Cada registre el veu qui toca, el pot tenir assignat
          una persona i es pot passar d'avís a tasca sense perdre el fil.
        </p>
        <p>
          Les <strong>tasques d'un Treball</strong> (obra, fulls, partides) són una altra cosa. Aquí parlem només
          d'Agenda.
        </p>
      </section>

      <section className="dv2-help-section">
        <h4>Avís</h4>
        <p>
          Un <strong>Avís</strong> és un recado. Algú ha contactat (trucada, e-mail, WhatsApp, presencial) i cal que
          una persona se n'enteri. Encara no és “feina al calendari”: és informació a tractar.
        </p>
        <ul>
          <li>
            Exemples: “Ha trucat el Sr. Ramon per en Carles”, “demanen informació d'un curs”, “volen que els truquem”.
          </li>
          <li>No cal data d'inici/final. La data que importa és l'alta i, si cal, les reiteracions.</li>
          <li>
            Taronja a la llista. A Nou, indica <strong>Tipus de contacte</strong> (Trucada, Email…).
          </li>
          <li>
            Quan ja saps què cal fer, <strong>converteix-lo en Tasca</strong> (canvia el tipus a Tasca i posa dates si
            en té). L'historial es conserva.
          </li>
        </ul>
      </section>

      <section className="dv2-help-section">
        <h4>Tasca</h4>
        <p>
          Una <strong>Tasca</strong> és feina teva o d'un company, amb o sense data al calendari: fer un pressupost,
          una reunió, la ITV, un recordatori intern.
        </p>
        <ul>
          <li>Blau a la llista. Si té Data inici (i opcionalment Data final), apareix al <strong>Calendari</strong>.</li>
          <li>
            Pots crear-la des de <strong>Nou</strong>, o amb doble clic a un dia del calendari (ja neix com a Tasca
            aquell dia).
          </li>
          <li>
            Relacionar-la amb un client o contacte és opcional. Si no cal, deixa el bloc tancat; el botó{" "}
            <strong>+ Relacionar amb un client, proveïdor o contacte</strong> l'obre.
          </li>
        </ul>
      </section>

      <section className="dv2-help-section">
        <h4>Estats</h4>
        <ul>
          <li>
            <strong>Pendent</strong>: encara no s'hi ha fet res. És l'estat en crear.
          </li>
          <li>
            <strong>En curs</strong>: s'hi està treballant.
          </li>
          <li>
            <strong>Finalitzat</strong>: acabat.
          </li>
          <li>
            <strong>Rebutjat</strong>: es guarda, però no molesta a la safata (filtre d'estat).
          </li>
        </ul>
        <p>La llista, per defecte, mostra Pendents + En curs. Els finalitzats i rebutjats s'han de demanar al filtre.</p>
      </section>

      <section className="dv2-help-section">
        <h4>Assignar no és el mateix que “qui ho veu”</h4>
        <p>
          <strong>Assignat a</strong> (a Nou) o <strong>Traspassat a</strong> (a Modificar) és el responsable actual:
          surt a la seva safata. <strong>Qui ho veu</strong> és l'abast de visibilitat, independent de qui el té
          assignat:
        </p>
        <ul>
          <li>
            <strong>Privat</strong>: només el creador, qui el té ara i qui l'ha tingut abans (cadena de traspassos). Un
            cap no el veu només per ser cap.
          </li>
          <li>
            <strong>Equip</strong>: cal un responsable. El veuen creador, assignat, antics assignats i usuaris amb
            nivell de rol igual o superior al de l'assignat actual.
          </li>
          <li>
            <strong>Empresa</strong>: tothom de la mateixa empresa. Pot no tenir assignat.
          </li>
          <li>
            <strong>Públic</strong>: qualsevol usuari de la base. També pot no tenir assignat.
          </li>
        </ul>
        <p>
          La safata per defecte són les <strong>Assignades</strong> a tu, no tot el que has creat. Si has recollit un
          avís per a un altre, mira <strong>Creades</strong> o la safata d'aquella persona.
        </p>
      </section>

      <section className="dv2-help-section">
        <h4>Traspassar</h4>
        <p>
          Obrir l'element en <strong>Modificar</strong> i canviar <strong>Traspassat a</strong>. En desar, deixa de ser
          teu (si ja no ets l'assignat) i passa a la safata de l'altre. Tu continues veient-lo si eres creador, si hi
          has participat, o si el nivell de visibilitat t'hi deixa.
        </p>
        <p>
          A la llista, el filtre <strong>Traspassades</strong> mostra el que tu (o l'usuari de la safata) heu passat a
          algú altre. <strong>Participades</strong> és tot allò on has estat responsable en algun moment.
        </p>
      </section>

      <section className="dv2-help-section">
        <h4>Llista</h4>
        <ul>
          <li>
            Doble clic a la fila per consultar. El menú <strong>…</strong> obre Consultar, Modificar o Esborrar.
          </li>
          <li>
            Badges <strong>Avisos / Tasques</strong>: es poden encendre i apagar (no els dos a la vegada buits). Canvien
            també les columnes (p. ex. adreça als avisos, dates a les tasques).
          </li>
          <li>
            <strong>Usuari</strong>: per defecte tu. Pots mirar la safata d'un company de nivell igual o inferior, o{" "}
            <strong>Tots</strong>. Si mires un altre, surt “Agenda de: …”.
          </li>
          <li>
            <strong>Estat / Relació</strong>: per defecte Pendents + En curs i Assignades. <strong>Tots</strong> treu
            aquest tall (tots els estats, o totes les relacions de l'usuari de la safata).
          </li>
        </ul>
      </section>

      <section className="dv2-help-section">
        <h4>Calendari</h4>
        <p>
          Vista simple: només el que està <strong>assignat</strong> a l'usuari triat. No porta els filtres de relació ni
          d'estat de la llista. Pots veure'l per <strong>mes</strong> o per <strong>any complet</strong> (com les
          absències). Esc torna a la llista.
        </p>
        <ul>
          <li>Les tasques amb data cauen als dies corresponents. Un avís, si es mostra, usa la data d'alta.</li>
          <li>
            Des del calendari només es creen <strong>Tasques</strong> (doble clic a un dia, o <strong>+ Tasca</strong>).
            Un avís s'apunta des de Nou a la llista: no té per què tenir data.
          </li>
          <li>Doble clic a una pastilla o a la taula del dia: modificar.</li>
        </ul>
      </section>

      <section className="dv2-help-section">
        <h4>Entitat i contacte</h4>
        <p>
          Un avís gairebé sempre té un “de part de qui”. El filtre de text estreta els dos selectors. Escollir una{" "}
          <strong>Entitat</strong> (client, proveïdor…) deixa només els seus contactes; si no tries contacte, l'avís
          queda lligat a l'entitat (telèfon i adreça de l'entitat, camps de persona buits).
        </p>
        <ul>
          <li>
            Si omples <strong>Nom i cognoms</strong> sobre una entitat sense contacte, estàs creant un contacte nou
            d'aquella entitat.
          </li>
          <li>
            Si tries un <strong>contacte</strong>, surten les seves dades. El “De part de” és l'entitat, si en té, i no
            es canvia.
          </li>
          <li>
            Sense cap selecció, amb <strong>Dades de contacte</strong> actiu, pots donar d'alta un contacte nou (tipus
            Altres).
          </li>
          <li>
            <strong>Modificar contacte</strong> (si ja n'hi ha un): desbloqueja nom, telèfon i e-mail. Sense marcar-ho,
            aquells camps són només lectura.
          </li>
        </ul>
        <p>
          En desar, si les dades s'assemblen a un contacte existent, el programa et pregunta si el reutilitzes o en
          crees un de nou. Val la pena reutilitzar: evites duplicats.
        </p>
      </section>

      <section className="dv2-help-section">
        <h4>Adreça: la de l'Agenda no és sempre la del contacte</h4>
        <p>
          L'adreça que es guarda a l'element és <strong>on aplica aquest avís o tasca</strong> (una obra, una visita, un
          lloc de reunió). Pot coincidir amb la del client o ser una altra. No assumeixis que canviar-la aquí actualitza
          la fitxa del contacte.
        </p>
        <ul>
          <li>
            <strong>Adreça</strong> (check): obre els camps. Si el contacte o l'entitat ja en tenien, es mostren en
            gris; en escriure a sobre, aquesta còpia passa a ser la de l'Agenda.
          </li>
          <li>
            <strong>Modificar l'adreça del contacte</strong>: només s'activa quan has tocat l'adreça <em>i</em> hi ha un
            contacte existent. Marca'l si vols que la nova adreça sigui també la del contacte a la base. Si el deixes
            desmarcat, el canvi queda <strong>només en aquest avís/tasca</strong>; la fitxa del contacte no es toca.
          </li>
          <li>
            Contacte nou sense marcar adreça: no se'n guarda cap. Entitat sense contacte: l'adreça inicial és la de
            l'entitat; si l'edites i marques el check, crea/actualitza segons el contacte que estiguis creant.
          </li>
        </ul>
      </section>

      <section className="dv2-help-section">
        <h4>Reiteracions</h4>
        <p>
          Si tornen a trucar pel mateix avís, a Modificar marca <strong>Reiteració</strong>. Queda constància a
          l'historial (quantes vegades i notes). No crea un avís nou: és el mateix fil.
        </p>
      </section>

      <section className="dv2-help-section">
        <h4>Resum ràpid</h4>
        <ul>
          <li>Recado → <strong>Avís</strong>. Feina amb data (o to-do) → <strong>Tasca</strong>.</li>
          <li>La safata són les <strong>assignades a tu</strong>, no tot el que has apuntat.</li>
          <li>Per passar-ho a un company: Modificar → <strong>Traspassat a</strong> → Desar.</li>
          <li>L'adreça de l'Agenda és d'aquest element; el check extra decideix si també canvia el contacte.</li>
        </ul>
      </section>
    </AjudaModal>
  );
}

export default AjudaAgenda;
